import * as React from "react";

const defaultStyle = {
  position: "fixed",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  inset: "0px",
  padding: "14vh 16px 16px",
  pointerEvents: 'none',
};

function getStyle(style) {
  return style ? { ...defaultStyle, ...style } : defaultStyle;
}

export const KBarPositioner =
  React.forwardRef(
    ({ style, children, ...props }, ref) => (
      <div ref={ref} style={getStyle(style)} {...props}>
        {children}
      </div>
    )
  );
